export function isAlphabeticlValid(alphabetic: string) {
  let valid;
  if (alphabetic != null || alphabetic !== "") {
    valid = alphabetic.match("^[A-Za-z]+$");
  }
  return valid === null ? false : valid;
}
